fragment AIChatMessageFragment on AIChatMessage {
  id
  role
  content
  status
  citations
  respondsTo
  startedAt
  endedAt
  modelId
  createdAt
  updatedAt
  error
  errorDetails
  feedbackRating
  feedbackComment
  tools {
    id
    result
    args
    thought
    status
    error
    errorDetails
    externalId
    callingAgentId
    modelId
    toolCalledAt
    toolResultAt
    createdAt
    updatedAt
  }
}



mutation upsertAIChat($input: UpsertAIChatInput!) {
  chat: upsertAIChat(input: $input) {
    id
    createdAt
    updatedAt
    messages {
      ...AIChatMessageFragment
    }
  }
}

mutation upsertAIChatMessage($input: UpsertAIChatMessageInput!) {
  message: upsertAIChatMessage(input: $input) {
    ...AIChatMessageFragment
  }
}

mutation updateAIChatMessageFeedback(
  $input: UpdateAIChatMessageFeedbackInput!
) {
  message: updateAIChatMessageFeedback(input: $input) {
    id
    feedbackRating
    feedbackComment
  }
}
